import InterfaceResume from "../apiInterface/InterfaceResume";
import { join, values, mapValues } from "lodash";
import ErrorAlert from "@/utility/ErrorAlert";

class DataResume {
  async getDataDiagnosa(term) {
    let dt = [];
    await InterfaceResume.getDiagnosis(term)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
      });
    return dt;
  }
  async getDataProcedure(term) {
    let dt = [];
    await InterfaceResume.getProcedure(term)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
      });
    return dt;
  }
  async getDataDischarge(term) {
    let dt = [];
    await InterfaceResume.getDischarge(term)
      .then(response => {
        dt = response.data;
        // console.log(dt)
      })
      .catch(e => {
        // console.log(e);
      });
    return dt;
  }
  async getDataResume(reg, idUser) {
    // let dt: object = {}
    let dt: any;
    await InterfaceResume.getResume(reg, idUser)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Resume");
        dt = e;
      });
    return dt;
  }
  async saveDataResume(
    reg,
    cm,
    dpjp,
    discharge,
    rujukan,
    catatan,
    user_id,
    diag,
    proc,
    tlPrb = null,
    tlPrbNote = null
  ) {
    let dt: object = {};
    await InterfaceResume.saveResume(
      reg,
      cm,
      dpjp,
      discharge,
      rujukan,
      catatan,
      user_id,
      diag,
      proc,
      tlPrb,
      tlPrbNote
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
        // ErrorAlert.showSnackAlert(e, "Resume");
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        //   // dt = e.response

        // }
        return Promise.reject(e);
      });
    return dt;
  }
  async editDataResume(
    reg,
    cm,
    dpjp,
    discharge,
    rujukan,
    catatan,
    user_id,
    diag,
    proc,
    tlPrb = null,
    tlPrbNote = null
  ) {
    let dt: object = {};
    await InterfaceResume.editResume(
      reg,
      cm,
      dpjp,
      discharge,
      rujukan,
      catatan,
      user_id,
      diag,
      proc,
      tlPrb,
      tlPrbNote
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e.response);
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        //   // dt = e.response

        // }
        // dt=e
      });
    return dt;
  }
  async saveDataTtdResume(reg, user_id, password) {
    let dt: object = {};
    // let validationErrors = {};
    await InterfaceResume.saveTtdResume(reg, user_id, password)
      .then(response => {
        dt = response;
      })
      .catch(e => {
        // console.log(e.response);
        dt = e.response;
        // ErrorAlert.showErrorAlert(e)
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        //   // dt = e.response

        // }
      });
    return dt;
  }
}

export default new DataResume();
